<template>
    <el-drawer class="w-el-drawer" :visible.sync="visible" :size="960" :with-header="false" direction="rtl" :before-close="Close" append-to-body destroy-on-close>

        
        <div class="w-el-drawer-header">
            <i class="el-icon-tickets"></i> 任务开始 - {{ task.name }}
        </div>

        
        <div class="w-el-drawer-body" v-loading.lock="loading">
            <el-form :model="form" label-width="120px" size="mini">

                <el-divider content-position="left">基础信息</el-divider>

                <el-form-item label="任务截止时间">
                    {{  task.start_date[1]  }}
                </el-form-item>
                <el-form-item label="任务预估工时">
                    {{  task.working_days  }} P
                </el-form-item>
                <el-form-item label="任务已用工时">
                    {{  task.consume_days  }} P
                </el-form-item>
                <el-form-item label="任务可用工时">
                    {{  (task.working_days - task.consume_days) > 0 ? (task.working_days - task.consume_days) : 0  }} P
                </el-form-item>

                <el-divider content-position="left">任务开始</el-divider>

                <el-form-item label="备注">
                    <froala-editor v-model="form.describe" />
                </el-form-item>
            </el-form>
        </div>

        
        <div class="w-el-drawer-footer">
            <el-button size="mini" @click="Close()">取消</el-button>
            <el-button size="mini" type="primary" @click="SubmitForm()" :disabled="loading">确定</el-button>
        </div>
    </el-drawer>
</template>

<script>

export default {
    data() {
        return {
                        visible: false,
            loading: false,

                        task: {
                start_date: []
            },

                        form: {
                describe: null,
            },
        }
    },
    methods: {
        async Open(row) {
            this.task = row
            this.visible = true
        },
        Close() {
            this.form.describe = null

            this.loading = false
            this.visible = false
        },
        SubmitForm() {
            this.$http.post('/9api/projects-task/flow-start', { id: this.task.id, form: this.form }).then(rps => {
                this.$emit('onSave')
                this.Close()
            })
        }
    }
}
</script>